import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  learnMoreAboutPremiumLinkLabel: {
    id: 'frontbucket.settings.premium.learnMoreAboutPremium',
    description: 'Label for the learn more about premium link',
    defaultMessage: 'Learn more about Premium',
  },
  upgradeLinkLabel: {
    id: 'frontbucket.settings.premium.upgradeToPremium',
    description: 'Label for the upgrade to premium link',
    defaultMessage: 'Upgrade',
  },
});
